// extracted by mini-css-extract-plugin
export default {"header":"XezCQlVXHPT871dC88Q8"};